import React from 'react'

import { CLASS_PREFIX } from 'src/constants'

import Icon from 'src/components/forms/icon/icon'
import { COLOR_TYPE_PRIMARY } from 'src/utils/color'

import {
  ProjectPreviewFragmentFragment,
  useFollowMutation,
  useUnfollowMutation
} from '@lopo-tech/lopo-api'
import { useHistory } from 'react-router-dom'
import NavigationItem from 'src/components/navigation_item/navigation_item'
import { ConstructionStatusTag } from 'src/components/projects/construction_status_tag/construction_status_tag'

import { textResources } from 'src/lang/de'
import { UrlUtils } from 'src/utils/url/url'
import './infrastructure_project_tile.scss'

const cls = `${CLASS_PREFIX}infrastructure-project-tile`

const t = textResources.projects

type IProps = {
  project: ProjectPreviewFragmentFragment;
};

const InfrastructureProjectTile: React.FC<IProps> = ({ project }) => {
  const history = useHistory()
  const [follow] = useFollowMutation()
  const [unfollow] = useUnfollowMutation()

  const onClickFollow = async () => {
    if (project.isFollowing) {
      await unfollow({
        variables: {
          input: {
            followeeId: project.id
          }
        }
      })
    } else {
      await follow({
        variables: {
          input: {
            followeeId: project.id
          }
        }
      })
    }
  }

  const image = project.images[0]?.file.previewUrl
  const detailsUrl = UrlUtils.projectDetailPage(project.slug, project.type)
  const responsibleProfile = project.projectMemberships?.items[0]?.profile

  return (
    <article className={`${cls}__card`}>
      <NavigationItem className={`${cls}__thumbnail`} onClick={() => history.push(detailsUrl)}>
        <img src={image} alt="" loading="lazy" />
        {responsibleProfile && (
          <img
            className={`${cls}__avatar`}
            src={responsibleProfile.avatar.previewUrl}
            alt=""
          />
        )}
      </NavigationItem>

      <div className={`${cls}__content`}>
        <NavigationItem className={`${cls}__card-title`} onClick={() => history.push(detailsUrl)}>
          {project.name}
        </NavigationItem>

        {project.teaser && (
          <p className={`${cls}__teaser`}>{project.teaser}</p>
        )}

        <ConstructionStatusTag status={project.constructionStatus} compact />
      </div>

      {project.canFollow.value && (
        <div className={`${cls}__action`}>
          <button
            type="button"
            aria-label={t.common.followProject}
            onClick={onClickFollow}
          >
            <Icon
              name={project.isFollowing ? 'check' : 'plus'}
              size={project.isFollowing ? 16 : 26}
              color={COLOR_TYPE_PRIMARY}
            />
          </button>
        </div>
      )}
    </article>
  )
}

export default InfrastructureProjectTile
